import _ from "lodash";

export const IMAGE_CDN = 'https://img.sumitas.jp/ph2';
export const MANAGE_DOMAIN = process.env.NODE_ENV === 'master'
  ? 'https://manage.sumitas-web.com'
  : 'https://stg.manage.sumitas-web.com';

/**
 * Get image URI from property saved images
 * @param propertySavedImages
 * @returns {string|undefined}
 */
export function getImageURI(propertySavedImages) {
  const propertySavedImageInOrder = _.minBy(propertySavedImages, (img) => img.propertyImages[0]?.image_ordering);
  return propertySavedImageInOrder?.uri;
}

/**
 * Get property image <img> tag with fallback
 * @param property
 * @param defaultImage
 * @param height
 * @param width
 * @returns {string}
 */
export function getPropertyImageTag(property, defaultImage, height = '150px', width = '150px') {
  if (!property.propertySavedImages?.length) {
    return `<img src="${defaultImage}" alt="" height="${height}" width="${width}">`;
  }

  const propertySavedImages = _.filter(property.propertySavedImages, (savedImage) => savedImage.propertyImages[0]?.division === '4');
  const images = propertySavedImages.length ? propertySavedImages : property.propertySavedImages;
  const imageURI = getImageURI(images);

  if (!imageURI) {
    return `<img src="${defaultImage}" alt="" height="${height}" width="${width}">`;
  }

  const path = imageURI.startsWith('/') ? imageURI : `/${imageURI}`;
  const cdnUrl = `${IMAGE_CDN}${path}`;
  const fallbackUrl = `${MANAGE_DOMAIN}${path}`;
  return `<img src="${cdnUrl}" alt="" height="${height}" width="${width}" onerror="this.onerror=null;this.src='${fallbackUrl}'">`;
}
